export const countryData = {
  QA: {
    cities: {
      en: [
        { label: '', value: '' },
        { label: 'Doha', value: 'DOHA' },
        { label: 'Al Wakrah', value: 'AL_WAKRAH' },
        { label: 'Al Khor', value: 'AL_KHOR' },
        { label: 'Al Rayyan', value: 'AL_RAYYAN' },
        { label: 'Umm Salal', value: 'UMM_SALAL' },
        { label: 'Madinat ash Shamal', value: 'MADINAT_ASH_SHAMAL' },
        { label: 'Al Daayen', value: 'AL_DAAYEN' },
        { label: 'Al Shahaniya', value: 'AL_SHAHANIYA' },
      ],
      ar: [
        { label: '', value: '' },
        { label: 'الدوحة', value: 'DOHA' },
        { label: 'الوكرة', value: 'AL_WAKRAH' },
        { label: 'الخور', value: 'AL_KHOR' },
        { label: 'الريان', value: 'AL_RAYYAN' },
        { label: 'أم صلال', value: 'UMM_SALAL' },
        { label: 'مدينة الشمال', value: 'MADINAT_ASH_SHAMAL' },
        { label: 'الظعاين', value: 'AL_DAAYEN' },
        { label: 'الشحانية', value: 'AL_SHAHANIYA' },
      ],
    },
    countryCode: 'QA',
    currency: { ar: 'ريال قطري', en: 'QAR' },
    vatRate: 5,
  },
  OM: {
    cities: {
      en: [
        { label: '', value: '' },
        { label: 'Muscat', value: 'MUSCAT' },
        { label: 'Salalah', value: 'SALALAH' },
        { label: 'Sohar', value: 'SOHAR' },
        { label: 'Nizwa', value: 'NIZWA' },
        { label: 'Sur', value: 'SUR' },
        { label: 'Barka', value: 'BARKA' },
        { label: 'Rustaq', value: 'RUSTAQ' },
        { label: 'Ibri', value: 'IBRI' },
        { label: 'Ibra', value: 'IBRA' },
        { label: 'Duqm', value: 'DUQM' },
        { label: 'Khasab', value: 'KHASAB' },
        { label: 'Bahla', value: 'BAHLA' },
        { label: 'Shinas', value: 'SHINAS' },
      ],
      ar: [
        { label: '', value: '' },
        { label: 'مسقط', value: 'MUSCAT' },
        { label: 'صلالة', value: 'SALALAH' },
        { label: 'صحار', value: 'SOHAR' },
        { label: 'نزوى', value: 'NIZWA' },
        { label: 'صور', value: 'SUR' },
        { label: 'بركاء', value: 'BARKA' },
        { label: 'الرستاق', value: 'RUSTAQ' },
        { label: 'عبري', value: 'IBRI' },
        { label: 'إبراء', value: 'IBRA' },
        { label: 'الدقم', value: 'DUQM' },
        { label: 'خصب', value: 'KHASAB' },
        { label: 'بهلاء', value: 'BAHLA' },
        { label: 'شناص', value: 'SHINAS' },
      ],
    },
    countryCode: 'OM',
    currency: { ar: 'ريال عماني', en: 'OMR' },
    vatRate: 5,
  },
  AE: {
    cities: {
      en: [
        { label: '', value: '' },
        { label: 'Abu Dhabi', value: 'ABU_DHABI' },
        { label: 'Dubai', value: 'DUBAI' },
        { label: 'Sharjah', value: 'SHARJAH' },
        { label: 'Ajman', value: 'AJMAN' },
        { label: 'Umm Al Quwain', value: 'UMM_AL_QUWAIN' },
        { label: 'Ras Al Khaimah', value: 'RAS_AL_KHAIMAH' },
        { label: 'Fujairah', value: 'FUJAIRAH' },
        { label: 'Al Ain', value: 'AL_AIN' },
        { label: 'Khor Fakkan', value: 'KHOR_FAKKAN' },
        { label: 'Dibba Al-Fujairah', value: 'DIBBA_AL_FUJAIRAH' },
      ],
      ar: [
        { label: '', value: '' },
        { label: 'أبو ظبي', value: 'ABU_DHABI' },
        { label: 'دبي', value: 'DUBAI' },
        { label: 'الشارقة', value: 'SHARJAH' },
        { label: 'عجمان', value: 'AJMAN' },
        { label: 'أم القيوين', value: 'UMM_AL_QUWAIN' },
        { label: 'رأس الخيمة', value: 'RAS_AL_KHAIMAH' },
        { label: 'الفجيرة', value: 'FUJAIRAH' },
        { label: 'العين', value: 'AL_AIN' },
        { label: 'خورفكان', value: 'KHOR_FAKKAN' },
        { label: 'دبا الفجيرة', value: 'DIBBA_AL_FUJAIRAH' },
      ],
    },
    currency: { ar: 'درهم إماراتي', en: 'AED' },
    countryCode: 'AE',
    vatRate: 5,
  },
  SA: {
    cities: {
      en: [
        { label: '', value: '' },
        { label: 'Riyadh', value: 'RIYADH' },
        { label: 'Jeddah', value: 'JEDDAH' },
        { label: 'Mecca', value: 'MECCA' },
        { label: 'Medina', value: 'MEDINA' },
        { label: 'Dammam', value: 'DAMMAM' },
        { label: 'Khobar', value: 'KHOBAR' },
        { label: 'Tabuk', value: 'TABUK' },
        { label: 'Buraydah', value: 'BURAYDAH' },
        { label: 'Khamis Mushait', value: 'KHAMIS_MUSHAIT' },
        { label: 'Hofuf', value: 'HOFUF' },
        { label: 'Hail', value: 'HAIL' },
        { label: 'Najran', value: 'NAJRAN' },
        { label: 'Abha', value: 'ABHA' },
        { label: 'Jubail', value: 'JUBAIL' },
        { label: 'Yanbu', value: 'YANBU' },
        { label: 'Al Qatif', value: 'AL_QATIF' },
        { label: 'Al Khafji', value: 'AL_KHAFJI' },
        { label: 'Al Bahah', value: 'AL_BAHAH' },
        { label: 'Arar', value: 'ARAR' },
        { label: 'Sakakah', value: 'SAKAKAH' },
        { label: 'Jizan', value: 'JIZAN' },
        { label: 'Qurayyat', value: 'QURAYYAT' },
        { label: 'Dhahran', value: 'DHAHRAN' },
        { label: 'Al Kharj', value: 'AL_KHARJ' },
        { label: 'Taif', value: 'TAIF' },
        { label: 'Al Mubarraz', value: 'AL_MUBARRAZ' },
        { label: 'Hafar Al-Batin', value: 'HAFAR_AL-BATIN' },
        { label: 'Al Jubayl', value: 'AL_JUBAYL' },
        { label: 'Al Qunfudhah', value: 'AL_QUNFUDHAH' },
        { label: 'Rabigh', value: 'RABIGH' },
        { label: 'Rafha', value: 'RAFHA' },
        { label: 'Ar Rass', value: 'AR_RASS' },
        { label: 'Ras Tanura', value: 'RAS_TANURA' },
        { label: 'Riyadh Al-Khabra', value: 'RIYADH_AL-KHABRA' },
        { label: 'Sabya', value: 'SABYA' },
        { label: 'Saihat', value: 'SAIHAT' },
        { label: 'Safwa', value: 'SAFWA' },
        { label: 'Sharurah', value: 'SHARURAH' },
        { label: 'Shaqra', value: 'SHAQRA' },
        { label: 'Taif', value: 'TAIF' },
        { label: 'Tabuk', value: 'TABUK' },
        { label: 'Tarout', value: 'TAROUT' },
        { label: 'Tayma', value: 'TAYMA' },
        { label: 'Thuwal', value: 'THUWAL' },
        { label: 'Turaif', value: 'TURAIF' },
        { label: 'Umluj', value: 'UMLUJ' },
        { label: 'Unaizah', value: 'UNAIZAH' },
        { label: 'Wadi Al-Dawasir', value: 'WADI_AL-DAWASIR' },
        { label: 'Al Wajh', value: 'AL_WAJH' },
        { label: 'Yanbu', value: 'YANBU' },
        { label: 'Zulfi', value: 'ZULFI' },
      ],
      ar: [
        { label: '', value: '' },
        { label: 'الرياض', value: 'RIYADH' },
        { label: 'جدة', value: 'JEDDAH' },
        { label: 'مكة', value: 'MECCA' },
        { label: 'المدينة المنورة', value: 'MEDINA' },
        { label: 'الدمام', value: 'DAMMAM' },
        { label: 'الخبر', value: 'KHOBAR' },
        { label: 'تبوك', value: 'TABUK' },
        { label: 'بريدة', value: 'BURAYDAH' },
        { label: 'خميس مشيط', value: 'KHAMIS_MUSHAIT' },
        { label: 'الهفوف', value: 'HOFUF' },
        { label: 'حائل', value: 'HAIL' },
        { label: 'نجران', value: 'NAJRAN' },
        { label: 'أبها', value: 'ABHA' },
        { label: 'الجبيل', value: 'JUBAIL' },
        { label: 'ينبع', value: 'YANBU' },
        { label: 'القطيف', value: 'AL_QATIF' },
        { label: 'الخفجي', value: 'AL_KHAFJI' },
        { label: 'الباحة', value: 'AL_BAHAH' },
        { label: 'عرعر', value: 'ARAR' },
        { label: 'سكاكا', value: 'SAKAKAH' },
        { label: 'جيزان', value: 'JIZAN' },
        { label: 'القريات', value: 'QURAYYAT' },
        { label: 'الظهران', value: 'DHAHRAN' },
        { label: 'الخرج', value: 'AL_KHARJ' },
        { label: 'الطائف', value: 'TAIF' },
        { label: 'المبرز', value: 'AL_MUBARRAZ' },
        { label: 'حفر الباطن', value: 'HAFAR_AL-BATIN' },
        { label: 'الجبيل', value: 'AL_JUBAYL' },
        { label: 'القنفذة', value: 'AL_QUNFUDHAH' },
        { label: 'رابغ', value: 'RABIGH' },
        { label: 'رفحاء', value: 'RAFHA' },
        { label: 'الرس', value: 'AR_RASS' },
        { label: 'رأس تنورة', value: 'RAS_TANURA' },
        { label: 'رياض الخبراء', value: 'RIYADH_AL-KHABRA' },
        { label: 'صبيا', value: 'SABYA' },
        { label: 'سيهات', value: 'SAIHAT' },
        { label: 'صفوى', value: 'SAFWA' },
        { label: 'شرورة', value: 'SHARURAH' },
        { label: 'شقراء', value: 'SHAQRA' },
        { label: 'ثول', value: 'THUWAL' },
        { label: 'تربة', value: 'TURAIF' },
        { label: 'أملج', value: 'UMLUJ' },
        { label: 'عنيزة', value: 'UNAIZAH' },
        { label: 'وادي الدواسر', value: 'WADI_AL-DAWASIR' },
        { label: 'الوجه', value: 'AL_WAJH' },
        { label: 'الزلفي', value: 'ZULFI' },
      ],
    },
    countryCode: 'SA',
    currency: { ar: 'ريال سعودي', en: 'SAR' },
    vatRate: 15,
  },
  BH: {
    cities: {
      en: [
        { label: '', value: '' },
        { label: 'Manama', value: 'MANAMA' },
        { label: 'Riffa', value: 'RIFFA' },
        { label: 'Muharraq', value: 'MUHARRAQ' },
        { label: 'Hamad Town', value: 'HAMAD_TOWN' },
        { label: 'Isa Town', value: 'ISA_TOWN' },
        { label: 'Sitra', value: 'SITRA' },
        { label: 'Budaiya', value: 'BUDAIYA' },
        { label: 'Jidhafs', value: 'JIDHAFS' },
        { label: 'Al Hidd', value: 'AL_HIDD' },
        { label: 'Zallaq', value: 'ZALLAQ' },
        { label: 'Dar Kulaib', value: 'DAR_KULAIB' },
        { label: 'Tubli', value: 'TUBLI' },
        { label: 'Jannusan', value: 'JANNUHAN' },
        { label: 'Salmabad', value: 'SALMABAD' },
        { label: 'Al Jasra', value: 'AL_JASRA' },
        { label: 'Sanabis', value: 'SANABIS' },
        { label: 'Barbar', value: 'BARBAR' },
        { label: 'Bani Jamra', value: 'BANI_JAMRA' },
        { label: 'Dumistan', value: 'DUMISTAN' },
      ],
      ar: [
        { label: '', value: '' },
        { label: 'المنامة', value: 'MANAMA' },
        { label: 'الرفاع', value: 'RIFFA' },
        { label: 'المحرق', value: 'MUHARRAQ' },
        { label: 'مدينة حمد', value: 'HAMAD_TOWN' },
        { label: 'مدينة عيسى', value: 'ISA_TOWN' },
        { label: 'سترة', value: 'SITRA' },
        { label: 'البديع', value: 'BUDAIYA' },
        { label: 'جد حفص', value: 'JIDHAFS' },
        { label: 'الحد', value: 'AL_HIDD' },
        { label: 'الزلاق', value: 'ZALLAQ' },
        { label: 'دار كليب', value: 'DAR_KULAIB' },
        { label: 'توبلي', value: 'TUBLI' },
        { label: 'جنوسان', value: 'JANNUHAN' },
        { label: 'سلماباد', value: 'SALMABAD' },
        { label: 'الجسرة', value: 'AL_JASRA' },
        { label: 'سنابس', value: 'SANABIS' },
        { label: 'باربار', value: 'BARBAR' },
        { label: 'بني جمرة', value: 'BANI_JAMRA' },
        { label: 'دمستان', value: 'DUMISTAN' },
      ],
    },
    countryCode: 'BH',
    currency: { ar: 'دينار بحريني', en: 'BHD' },
    vatRate: 10,
  },
};

export const countries = {
  en: [
    {
      value: '',
      label: 'Select country',
    },
    {
      value: 'AD',
      label: 'Andorra',
    },
    {
      value: 'AE',
      label: 'United Arab Emirates',
    },
    {
      value: 'AF',
      label: 'Afghanistan',
    },
    {
      value: 'AG',
      label: 'Antigua and Barbuda',
    },
    {
      value: 'AI',
      label: 'Anguilla',
    },
    {
      value: 'AL',
      label: 'Albania',
    },
    {
      value: 'AM',
      label: 'Armenia',
    },
    {
      value: 'AO',
      label: 'Angola',
    },
    {
      value: 'AQ',
      label: 'Antarctica',
    },
    {
      value: 'AR',
      label: 'Argentina',
    },
    {
      value: 'AS',
      label: 'American Samoa',
    },
    {
      value: 'AT',
      label: 'Austria',
    },
    {
      value: 'AU',
      label: 'Australia',
    },
    {
      value: 'AW',
      label: 'Aruba',
    },
    {
      value: 'AX',
      label: 'Åland Islands',
    },
    {
      value: 'AZ',
      label: 'Azerbaijan',
    },
    {
      value: 'BA',
      label: 'Bosnia and Herzegovina',
    },
    {
      value: 'BB',
      label: 'Barbados',
    },
    {
      value: 'BD',
      label: 'Bangladesh',
    },
    {
      value: 'BE',
      label: 'Belgium',
    },
    {
      value: 'BF',
      label: 'Burkina Faso',
    },
    {
      value: 'BG',
      label: 'Bulgaria',
    },
    {
      value: 'BH',
      label: 'Bahrain',
    },
    {
      value: 'BI',
      label: 'Burundi',
    },
    {
      value: 'BJ',
      label: 'Benin',
    },
    {
      value: 'BL',
      label: 'Saint Barthélemy',
    },
    {
      value: 'BM',
      label: 'Bermuda',
    },
    {
      value: 'BN',
      label: 'Brunei Darussalam',
    },
    {
      value: 'BO',
      label: 'Bolivia, Plurinational State of',
    },
    {
      value: 'BQ',
      label: 'Bonaire, Sint Eustatius and Saba',
    },
    {
      value: 'BR',
      label: 'Brazil',
    },
    {
      value: 'BS',
      label: 'Bahamas',
    },
    {
      value: 'BT',
      label: 'Bhutan',
    },
    {
      value: 'BV',
      label: 'Bouvet Island',
    },
    {
      value: 'BW',
      label: 'Botswana',
    },
    {
      value: 'BY',
      label: 'Belarus',
    },
    {
      value: 'BZ',
      label: 'Belize',
    },
    {
      value: 'CA',
      label: 'Canada',
    },
    {
      value: 'CC',
      label: 'Cocos (Keeling) Islands',
    },
    {
      value: 'CD',
      label: 'Congo, the Democratic Republic of the',
    },
    {
      value: 'CF',
      label: 'Central African Republic',
    },
    {
      value: 'CG',
      label: 'Congo',
    },
    {
      value: 'CH',
      label: 'Switzerland',
    },
    {
      value: 'CI',
      label: "Côte d'Ivoire",
    },
    {
      value: 'CK',
      label: 'Cook Islands',
    },
    {
      value: 'CL',
      label: 'Chile',
    },
    {
      value: 'CM',
      label: 'Cameroon',
    },
    {
      value: 'CN',
      label: 'China',
    },
    {
      value: 'CO',
      label: 'Colombia',
    },
    {
      value: 'CR',
      label: 'Costa Rica',
    },
    {
      value: 'CU',
      label: 'Cuba',
    },
    {
      value: 'CV',
      label: 'Cabo Verde',
    },
    {
      value: 'CW',
      label: 'Curaçao',
    },
    {
      value: 'CX',
      label: 'Christmas Island',
    },
    {
      value: 'CY',
      label: 'Cyprus',
    },
    {
      value: 'CZ',
      label: 'Czechia',
    },
    {
      value: 'DE',
      label: 'Germany',
    },
    {
      value: 'DJ',
      label: 'Djibouti',
    },
    {
      value: 'DK',
      label: 'Denmark',
    },
    {
      value: 'DM',
      label: 'Dominica',
    },
    {
      value: 'DO',
      label: 'Dominican Republic',
    },
    {
      value: 'DZ',
      label: 'Algeria',
    },
    {
      value: 'EC',
      label: 'Ecuador',
    },
    {
      value: 'EE',
      label: 'Estonia',
    },
    {
      value: 'EG',
      label: 'Egypt',
    },
    {
      value: 'EH',
      label: 'Western Sahara',
    },
    {
      value: 'ER',
      label: 'Eritrea',
    },
    {
      value: 'ES',
      label: 'Spain',
    },
    {
      value: 'ET',
      label: 'Ethiopia',
    },
    {
      value: 'FI',
      label: 'Finland',
    },
    {
      value: 'FJ',
      label: 'Fiji',
    },
    {
      value: 'FK',
      label: 'Falkland Islands (Malvinas)',
    },
    {
      value: 'FM',
      label: 'Micronesia, Federated States of',
    },
    {
      value: 'FO',
      label: 'Faroe Islands',
    },
    {
      value: 'FR',
      label: 'France',
    },
    {
      value: 'GA',
      label: 'Gabon',
    },
    {
      value: 'GB',
      label: 'United Kingdom of Great Britain and Northern Ireland',
    },
    {
      value: 'GD',
      label: 'Grenada',
    },
    {
      value: 'GE',
      label: 'Georgia',
    },
    {
      value: 'GF',
      label: 'French Guiana',
    },
    {
      value: 'GG',
      label: 'Guernsey',
    },
    {
      value: 'GH',
      label: 'Ghana',
    },
    {
      value: 'GI',
      label: 'Gibraltar',
    },
    {
      value: 'GL',
      label: 'Greenland',
    },
    {
      value: 'GM',
      label: 'Gambia',
    },
    {
      value: 'GN',
      label: 'Guinea',
    },
    {
      value: 'GP',
      label: 'Guadeloupe',
    },
    {
      value: 'GQ',
      label: 'Equatorial Guinea',
    },
    {
      value: 'GR',
      label: 'Greece',
    },
    {
      value: 'GS',
      label: 'South Georgia and the South Sandwich Islands',
    },
    {
      value: 'GT',
      label: 'Guatemala',
    },
    {
      value: 'GU',
      label: 'Guam',
    },
    {
      value: 'GW',
      label: 'Guinea-Bissau',
    },
    {
      value: 'GY',
      label: 'Guyana',
    },
    {
      value: 'HK',
      label: 'Hong Kong',
    },
    {
      value: 'HM',
      label: 'Heard Island and McDonald Islands',
    },
    {
      value: 'HN',
      label: 'Honduras',
    },
    {
      value: 'HR',
      label: 'Croatia',
    },
    {
      value: 'HT',
      label: 'Haiti',
    },
    {
      value: 'HU',
      label: 'Hungary',
    },
    {
      value: 'ID',
      label: 'Indonesia',
    },
    {
      value: 'IE',
      label: 'Ireland',
    },
    {
      value: 'IM',
      label: 'Isle of Man',
    },
    {
      value: 'IN',
      label: 'India',
    },
    {
      value: 'IO',
      label: 'British Indian Ocean Territory',
    },
    {
      value: 'IQ',
      label: 'Iraq',
    },
    {
      value: 'IR',
      label: 'Iran, Islamic Republic of',
    },
    {
      value: 'IS',
      label: 'Iceland',
    },
    {
      value: 'IT',
      label: 'Italy',
    },
    {
      value: 'JE',
      label: 'Jersey',
    },
    {
      value: 'JM',
      label: 'Jamaica',
    },
    {
      value: 'JO',
      label: 'Jordan',
    },
    {
      value: 'JP',
      label: 'Japan',
    },
    {
      value: 'KE',
      label: 'Kenya',
    },
    {
      value: 'KG',
      label: 'Kyrgyzstan',
    },
    {
      value: 'KH',
      label: 'Cambodia',
    },
    {
      value: 'KI',
      label: 'Kiribati',
    },
    {
      value: 'KM',
      label: 'Comoros',
    },
    {
      value: 'KN',
      label: 'Saint Kitts and Nevis',
    },
    {
      value: 'KP',
      label: "Korea, Democratic People's Republic of",
    },
    {
      value: 'KR',
      label: 'Korea, Republic of',
    },
    {
      value: 'KW',
      label: 'Kuwait',
    },
    {
      value: 'KY',
      label: 'Cayman Islands',
    },
    {
      value: 'KZ',
      label: 'Kazakhstan',
    },
    {
      value: 'LA',
      label: "Lao People's Democratic Republic",
    },
    {
      value: 'LB',
      label: 'Lebanon',
    },
    {
      value: 'LC',
      label: 'Saint Lucia',
    },
    {
      value: 'LI',
      label: 'Liechtenstein',
    },
    {
      value: 'LK',
      label: 'Sri Lanka',
    },
    {
      value: 'LR',
      label: 'Liberia',
    },
    {
      value: 'LS',
      label: 'Lesotho',
    },
    {
      value: 'LT',
      label: 'Lithuania',
    },
    {
      value: 'LU',
      label: 'Luxembourg',
    },
    {
      value: 'LV',
      label: 'Latvia',
    },
    {
      value: 'LY',
      label: 'Libya',
    },
    {
      value: 'MA',
      label: 'Morocco',
    },
    {
      value: 'MC',
      label: 'Monaco',
    },
    {
      value: 'MD',
      label: 'Moldova, Republic of',
    },
    {
      value: 'ME',
      label: 'Montenegro',
    },
    {
      value: 'MF',
      label: 'Saint Martin (French part)',
    },
    {
      value: 'MG',
      label: 'Madagascar',
    },
    {
      value: 'MH',
      label: 'Marshall Islands',
    },
    {
      value: 'MK',
      label: 'Macedonia, the former Yugoslav Republic of',
    },
    {
      value: 'ML',
      label: 'Mali',
    },
    {
      value: 'MM',
      label: 'Myanmar',
    },
    {
      value: 'MN',
      label: 'Mongolia',
    },
    {
      value: 'MO',
      label: 'Macao',
    },
    {
      value: 'MP',
      label: 'Northern Mariana Islands',
    },
    {
      value: 'MQ',
      label: 'Martinique',
    },
    {
      value: 'MR',
      label: 'Mauritania',
    },
    {
      value: 'MS',
      label: 'Montserrat',
    },
    {
      value: 'MT',
      label: 'Malta',
    },
    {
      value: 'MU',
      label: 'Mauritius',
    },
    {
      value: 'MV',
      label: 'Maldives',
    },
    {
      value: 'MW',
      label: 'Malawi',
    },
    {
      value: 'MX',
      label: 'Mexico',
    },
    {
      value: 'MY',
      label: 'Malaysia',
    },
    {
      value: 'MZ',
      label: 'Mozambique',
    },
    {
      value: 'NA',
      label: 'Namibia',
    },
    {
      value: 'NC',
      label: 'New Caledonia',
    },
    {
      value: 'NE',
      label: 'Niger',
    },
    {
      value: 'NF',
      label: 'Norfolk Island',
    },
    {
      value: 'NG',
      label: 'Nigeria',
    },
    {
      value: 'NI',
      label: 'Nicaragua',
    },
    {
      value: 'NL',
      label: 'Netherlands',
    },
    {
      value: 'NO',
      label: 'Norway',
    },
    {
      value: 'NP',
      label: 'Nepal',
    },
    {
      value: 'NR',
      label: 'Nauru',
    },
    {
      value: 'NU',
      label: 'Niue',
    },
    {
      value: 'NZ',
      label: 'New Zealand',
    },
    {
      value: 'OM',
      label: 'Oman',
    },
    {
      value: 'PA',
      label: 'Panama',
    },
    {
      value: 'PE',
      label: 'Peru',
    },
    {
      value: 'PF',
      label: 'French Polynesia',
    },
    {
      value: 'PG',
      label: 'Papua New Guinea',
    },
    {
      value: 'PH',
      label: 'Philippines',
    },
    {
      value: 'PK',
      label: 'Pakistan',
    },
    {
      value: 'PL',
      label: 'Poland',
    },
    {
      value: 'PM',
      label: 'Saint Pierre and Miquelon',
    },
    {
      value: 'PN',
      label: 'Pitcairn',
    },
    {
      value: 'PR',
      label: 'Puerto Rico',
    },
    {
      value: 'PS',
      label: 'Palestine',
    },
    {
      value: 'PT',
      label: 'Portugal',
    },
    {
      value: 'PW',
      label: 'Palau',
    },
    {
      value: 'PY',
      label: 'Paraguay',
    },
    {
      value: 'QA',
      label: 'Qatar',
    },
    {
      value: 'RE',
      label: 'Réunion',
    },
    {
      value: 'RO',
      label: 'Romania',
    },
    {
      value: 'RS',
      label: 'Serbia',
    },
    {
      value: 'RU',
      label: 'Russian Federation',
    },
    {
      value: 'RW',
      label: 'Rwanda',
    },
    {
      value: 'SA',
      label: 'Saudi Arabia',
    },
    {
      value: 'SB',
      label: 'Solomon Islands',
    },
    {
      value: 'SC',
      label: 'Seychelles',
    },
    {
      value: 'SD',
      label: 'Sudan',
    },
    {
      value: 'SE',
      label: 'Sweden',
    },
    {
      value: 'SG',
      label: 'Singapore',
    },
    {
      value: 'SH',
      label: 'Saint Helena, Ascension and Tristan da Cunha',
    },
    {
      value: 'SI',
      label: 'Slovenia',
    },
    {
      value: 'SJ',
      label: 'Svalbard and Jan Mayen',
    },
    {
      value: 'SK',
      label: 'Slovakia',
    },
    {
      value: 'SL',
      label: 'Sierra Leone',
    },
    {
      value: 'SM',
      label: 'San Marino',
    },
    {
      value: 'SN',
      label: 'Senegal',
    },
    {
      value: 'SO',
      label: 'Somalia',
    },
    {
      value: 'SR',
      label: 'Suriname',
    },
    {
      value: 'SS',
      label: 'South Sudan',
    },
    {
      value: 'ST',
      label: 'Sao Tome and Principe',
    },
    {
      value: 'SV',
      label: 'El Salvador',
    },
    {
      value: 'SX',
      label: 'Sint Maarten (Dutch part)',
    },
    {
      value: 'SY',
      label: 'Syrian Arab Republic',
    },
    {
      value: 'SZ',
      label: 'Swaziland',
    },
    {
      value: 'TC',
      label: 'Turks and Caicos Islands',
    },
    {
      value: 'TD',
      label: 'Chad',
    },
    {
      value: 'TF',
      label: 'French Southern Territories',
    },
    {
      value: 'TG',
      label: 'Togo',
    },
    {
      value: 'TH',
      label: 'Thailand',
    },
    {
      value: 'TJ',
      label: 'Tajikistan',
    },
    {
      value: 'TK',
      label: 'Tokelau',
    },
    {
      value: 'TL',
      label: 'Timor-Leste',
    },
    {
      value: 'TM',
      label: 'Turkmenistan',
    },
    {
      value: 'TN',
      label: 'Tunisia',
    },
    {
      value: 'TO',
      label: 'Tonga',
    },
    {
      value: 'TR',
      label: 'Turkey',
    },
    {
      value: 'TT',
      label: 'Trinidad and Tobago',
    },
    {
      value: 'TV',
      label: 'Tuvalu',
    },
    {
      value: 'TW',
      label: 'Taiwan, Province of China',
    },
    {
      value: 'TZ',
      label: 'Tanzania, United Republic of',
    },
    {
      value: 'UA',
      label: 'Ukraine',
    },
    {
      value: 'UG',
      label: 'Uganda',
    },
    {
      value: 'UM',
      label: 'United States Minor Outlying Islands',
    },
    {
      value: 'US',
      label: 'United States of America',
    },
    {
      value: 'UY',
      label: 'Uruguay',
    },
    {
      value: 'UZ',
      label: 'Uzbekistan',
    },
    {
      value: 'VA',
      label: 'Holy See',
    },
    {
      value: 'VC',
      label: 'Saint Vincent and the Grenadines',
    },
    {
      value: 'VE',
      label: 'Venezuela, Bolivarian Republic of',
    },
    {
      value: 'VG',
      label: 'Virgin Islands, British',
    },
    {
      value: 'VI',
      label: 'Virgin Islands, U.S.',
    },
    {
      value: 'VN',
      label: 'Viet Nam',
    },
    {
      value: 'VU',
      label: 'Vanuatu',
    },
    {
      value: 'WF',
      label: 'Wallis and Futuna',
    },
    {
      value: 'WS',
      label: 'Samoa',
    },
    {
      value: 'YE',
      label: 'Yemen',
    },
    {
      value: 'YT',
      label: 'Mayotte',
    },
    {
      value: 'ZA',
      label: 'South Africa',
    },
    {
      value: 'ZM',
      label: 'Zambia',
    },
    {
      value: 'ZW',
      label: 'Zimbabwe',
    },
    {
      value: '1A',
      label: 'Kosovo',
    },
    {
      value: 'XI',
      label: 'United Kingdom (Northern Ireland)',
    },
  ].map((country) => ({
    value: country.value,
    label: country.value
      ? `${country.value} - ${country.label}`
      : country.label,
  })),
  ar: [
    {
      value: '',
      label: 'اختر الدولة',
    },
    { value: 'AD', label: 'أندورا' },
    { value: 'AE', label: 'الإمارات العربية المتحدة' },
    { value: 'AF', label: 'أفغانستان' },
    { value: 'AG', label: 'أنتيغوا وبربودا' },
    { value: 'AI', label: 'أنغويلا' },
    { value: 'AL', label: 'ألبانيا' },
    { value: 'AM', label: 'أرمينيا' },
    { value: 'AO', label: 'أنغولا' },
    { value: 'AQ', label: 'القارة القطبية الجنوبية' },
    { value: 'AR', label: 'الأرجنتين' },
    { value: 'AS', label: 'ساموا الأمريكية' },
    { value: 'AT', label: 'النمسا' },
    { value: 'AU', label: 'أستراليا' },
    { value: 'AW', label: 'أروبا' },
    { value: 'AX', label: 'جزر آلاند' },
    { value: 'AZ', label: 'أذربيجان' },
    { value: 'BA', label: 'البوسنة والهرسك' },
    { value: 'BB', label: 'بربادوس' },
    { value: 'BD', label: 'بنغلاديش' },
    { value: 'BE', label: 'بلجيكا' },
    { value: 'BF', label: 'بوركينا فاسو' },
    { value: 'BG', label: 'بلغاريا' },
    { value: 'BH', label: 'البحرين' },
    { value: 'BI', label: 'بوروندي' },
    { value: 'BJ', label: 'بنين' },
    { value: 'BL', label: 'سان بارتيلمي' },
    { value: 'BM', label: 'برمودا' },
    { value: 'BN', label: 'بروناي' },
    { value: 'BO', label: 'بوليفيا' },
    { value: 'BQ', label: 'بونير وسانت أوستاتيوس وسابا' },
    { value: 'BR', label: 'البرازيل' },
    { value: 'BS', label: 'جزر البهاما' },
    { value: 'BT', label: 'بوتان' },
    { value: 'BV', label: 'جزيرة بوفيت' },
    { value: 'BW', label: 'بوتسوانا' },
    { value: 'BY', label: 'بيلاروسيا' },
    { value: 'BZ', label: 'بليز' },
    { value: 'CA', label: 'كندا' },
    { value: 'CC', label: 'جزر كوكوس' },
    { value: 'CD', label: 'جمهورية الكونغو الديمقراطية' },
    { value: 'CF', label: 'جمهورية أفريقيا الوسطى' },
    { value: 'CG', label: 'الكونغو' },
    { value: 'CH', label: 'سويسرا' },
    { value: 'CI', label: 'ساحل العاج' },
    { value: 'CK', label: 'جزر كوك' },
    { value: 'CL', label: 'تشيلي' },
    { value: 'CM', label: 'الكاميرون' },
    { value: 'CN', label: 'الصين' },
    { value: 'CO', label: 'كولومبيا' },
    { value: 'CR', label: 'كوستاريكا' },
    { value: 'CU', label: 'كوبا' },
    { value: 'CV', label: 'الرأس الأخضر' },
    { value: 'CW', label: 'كوراساو' },
    { value: 'CX', label: 'جزيرة الكريسماس' },
    { value: 'CY', label: 'قبرص' },
    { value: 'CZ', label: 'التشيك' },
    { value: 'DE', label: 'ألمانيا' },
    { value: 'DJ', label: 'جيبوتي' },
    { value: 'DK', label: 'الدنمارك' },
    { value: 'DM', label: 'دومينيكا' },
    { value: 'DO', label: 'جمهورية الدومينيكان' },
    { value: 'DZ', label: 'الجزائر' },
    { value: 'EC', label: 'الإكوادور' },
    { value: 'EE', label: 'إستونيا' },
    { value: 'EG', label: 'مصر' },
    { value: 'EH', label: 'الصحراء الغربية' },
    { value: 'ER', label: 'إريتريا' },
    { value: 'ES', label: 'إسبانيا' },
    { value: 'ET', label: 'إثيوبيا' },
    { value: 'FI', label: 'فنلندا' },
    { value: 'FJ', label: 'فيجي' },
    { value: 'FK', label: 'جزر فوكلاند' },
    { value: 'FM', label: 'ميكرونيزيا' },
    { value: 'FO', label: 'جزر فارو' },
    { value: 'FR', label: 'فرنسا' },
    { value: 'GA', label: 'الغابون' },
    { value: 'GB', label: 'المملكة المتحدة' },
    { value: 'GD', label: 'غرينادا' },
    { value: 'GE', label: 'جورجيا' },
    { value: 'GF', label: 'غويانا الفرنسية' },
    { value: 'GG', label: 'غيرنزي' },
    { value: 'GH', label: 'غانا' },
    { value: 'GI', label: 'جبل طارق' },
    { value: 'GL', label: 'غرينلاند' },
    { value: 'GM', label: 'غامبيا' },
    { value: 'GN', label: 'غينيا' },
    { value: 'GP', label: 'غوادلوب' },
    { value: 'GQ', label: 'غينيا الاستوائية' },
    { value: 'GR', label: 'اليونان' },
    { value: 'GS', label: 'جورجيا الجنوبية وجزر ساندويتش الجنوبية' },
    { value: 'GT', label: 'غواتيمالا' },
    { value: 'GU', label: 'غوام' },
    { value: 'GW', label: 'غينيا بيساو' },
    { value: 'GY', label: 'غيانا' },
    { value: 'HK', label: 'هونغ كونغ' },
    { value: 'HM', label: 'جزيرة هيرد وجزر ماكدونالد' },
    { value: 'HN', label: 'هندوراس' },
    { value: 'HR', label: 'كرواتيا' },
    { value: 'HT', label: 'هايتي' },
    { value: 'HU', label: 'المجر' },
    { value: 'ID', label: 'إندونيسيا' },
    { value: 'IE', label: 'أيرلندا' },
    { value: 'IL', label: 'إسرائيل' },
    { value: 'IM', label: 'جزيرة مان' },
    { value: 'IN', label: 'الهند' },
    { value: 'IO', label: 'إقليم المحيط الهندي البريطاني' },
    { value: 'IQ', label: 'العراق' },
    { value: 'IR', label: 'إيران' },
    { value: 'IS', label: 'آيسلندا' },
    { value: 'IT', label: 'إيطاليا' },
    { value: 'JE', label: 'جيرزي' },
    { value: 'JM', label: 'جامايكا' },
    { value: 'JO', label: 'الأردن' },
    { value: 'JP', label: 'اليابان' },
    { value: 'KE', label: 'كينيا' },
    { value: 'KG', label: 'قيرغيزستان' },
    { value: 'KH', label: 'كمبوديا' },
    { value: 'KI', label: 'كيريباتي' },
    { value: 'KM', label: 'جزر القمر' },
    { value: 'KN', label: 'سانت كيتس ونيفيس' },
    { value: 'KP', label: 'كوريا الشمالية' },
    { value: 'KR', label: 'كوريا الجنوبية' },
    { value: 'KW', label: 'الكويت' },
    { value: 'KY', label: 'جزر كايمان' },
    { value: 'KZ', label: 'كازاخستان' },
    { value: 'LA', label: 'لاوس' },
    { value: 'LB', label: 'لبنان' },
    { value: 'LC', label: 'سانت لوسيا' },
    { value: 'LI', label: 'ليختنشتاين' },
    { value: 'LK', label: 'سريلانكا' },
    { value: 'LR', label: 'ليبيريا' },
    { value: 'LS', label: 'ليسوتو' },
    { value: 'LT', label: 'ليتوانيا' },
    { value: 'LU', label: 'لوكسمبورغ' },
    { value: 'LV', label: 'لاتفيا' },
    { value: 'LY', label: 'ليبيا' },
    { value: 'MA', label: 'المغرب' },
    { value: 'MC', label: 'موناكو' },
    { value: 'MD', label: 'مولدوفا' },
    { value: 'ME', label: 'الجبل الأسود' },
    { value: 'MF', label: 'سانت مارتن' },
    { value: 'MG', label: 'مدغشقر' },
    { value: 'MH', label: 'جزر مارشال' },
    { value: 'MK', label: 'مقدونيا الشمالية' },
    { value: 'ML', label: 'مالي' },
    { value: 'MM', label: 'ميانمار' },
    { value: 'MN', label: 'منغوليا' },
    { value: 'MO', label: 'ماكاو' },
    { value: 'MP', label: 'جزر ماريانا الشمالية' },
    { value: 'MQ', label: 'مارتينيك' },
    { value: 'MR', label: 'موريتانيا' },
    { value: 'MS', label: 'مونتسرات' },
    { value: 'MT', label: 'مالطا' },
    { value: 'MU', label: 'موريشيوس' },
    { value: 'MV', label: 'جزر المالديف' },
    { value: 'MW', label: 'ملاوي' },
    { value: 'MX', label: 'المكسيك' },
    { value: 'MY', label: 'ماليزيا' },
    { value: 'MZ', label: 'موزمبيق' },
    { value: 'NA', label: 'ناميبيا' },
    { value: 'NC', label: 'كاليدونيا الجديدة' },
    { value: 'NE', label: 'النيجر' },
    { value: 'NF', label: 'جزيرة نورفولك' },
    { value: 'NG', label: 'نيجيريا' },
    { value: 'NI', label: 'نيكاراغوا' },
    { value: 'NL', label: 'هولندا' },
    { value: 'NO', label: 'النرويج' },
    { value: 'NP', label: 'نيبال' },
    { value: 'NR', label: 'ناورو' },
    { value: 'NU', label: 'نيوي' },
    { value: 'NZ', label: 'نيوزيلندا' },
    { value: 'OM', label: 'عمان' },
    { value: 'PA', label: 'بنما' },
    { value: 'PE', label: 'بيرو' },
    { value: 'PF', label: 'بولينزيا الفرنسية' },
    { value: 'PG', label: 'بابوا غينيا الجديدة' },
    { value: 'PH', label: 'الفلبين' },
    { value: 'PK', label: 'باكستان' },
    { value: 'PL', label: 'بولندا' },
    { value: 'PM', label: 'سانت بيير وميكلون' },
    { value: 'PN', label: 'جزر بيتكيرن' },
    { value: 'PR', label: 'بورتوريكو' },
    { value: 'PS', label: 'فلسطين' },
    { value: 'PT', label: 'البرتغال' },
    { value: 'PW', label: 'بالاو' },
    { value: 'PY', label: 'باراغواي' },
    { value: 'QA', label: 'قطر' },
    { value: 'RE', label: 'لا ريونيون' },
    { value: 'RO', label: 'رومانيا' },
    { value: 'RS', label: 'صربيا' },
    { value: 'RU', label: 'روسيا' },
    { value: 'RW', label: 'رواندا' },
    { value: 'SA', label: 'المملكة العربية السعودية' },
    { value: 'SB', label: 'جزر سليمان' },
    { value: 'SC', label: 'سيشل' },
    { value: 'SD', label: 'السودان' },
    { value: 'SE', label: 'السويد' },
    { value: 'SG', label: 'سنغافورة' },
    { value: 'SH', label: 'سانت هيلينا' },
    { value: 'SI', label: 'سلوفينيا' },
    { value: 'SJ', label: 'سفالبارد ويان ماين' },
    { value: 'SK', label: 'سلوفاكيا' },
    { value: 'SL', label: 'سيراليون' },
    { value: 'SM', label: 'سان مارينو' },
    { value: 'SN', label: 'السنغال' },
    { value: 'SO', label: 'الصومال' },
    { value: 'SR', label: 'سورينام' },
    { value: 'SS', label: 'جنوب السودان' },
    { value: 'ST', label: 'ساو تومي وبرينسيب' },
    { value: 'SV', label: 'السلفادور' },
    { value: 'SX', label: 'سانت مارتن' },
    { value: 'SY', label: 'سوريا' },
    { value: 'SZ', label: 'إسواتيني' },
    { value: 'TC', label: 'جزر توركس وكايكوس' },
    { value: 'TD', label: 'تشاد' },
    { value: 'TF', label: 'الأراضي الفرنسية الجنوبية' },
    { value: 'TG', label: 'توغو' },
    { value: 'TH', label: 'تايلاند' },
    { value: 'TJ', label: 'طاجيكستان' },
    { value: 'TK', label: 'توكيلاو' },
    { value: 'TL', label: 'تيمور الشرقية' },
    { value: 'TM', label: 'تركمانستان' },
    { value: 'TN', label: 'تونس' },
    { value: 'TO', label: 'تونغا' },
    { value: 'TR', label: 'تركيا' },
    { value: 'TT', label: 'ترينيداد وتوباغو' },
    { value: 'TV', label: 'توفالو' },
    { value: 'TW', label: 'تايوان' },
    { value: 'TZ', label: 'تنزانيا' },
    { value: 'UA', label: 'أوكرانيا' },
    { value: 'UG', label: 'أوغندا' },
    { value: 'UM', label: 'جزر الولايات المتحدة الصغيرة النائية' },
    { value: 'US', label: 'الولايات المتحدة الأمريكية' },
    { value: 'UY', label: 'أوروغواي' },
    { value: 'UZ', label: 'أوزبكستان' },
    { value: 'VA', label: 'الفاتيكان' },
    { value: 'VC', label: 'سانت فينسنت والغرينادين' },
    { value: 'VE', label: 'فنزويلا' },
    { value: 'VG', label: 'جزر العذراء البريطانية' },
    { value: 'VI', label: 'جزر العذراء الأمريكية' },
    { value: 'VN', label: 'فيتنام' },
    { value: 'VU', label: 'فانواتو' },
    { value: 'WF', label: 'واليس وفوتونا' },
    { value: 'WS', label: 'ساموا' },
    { value: 'YE', label: 'اليمن' },
    { value: 'YT', label: 'مايوت' },
    { value: 'ZA', label: 'جنوب أفريقيا' },
    { value: 'ZM', label: 'زامبيا' },
    { value: 'ZW', label: 'زيمبابوي' },
    { value: '1A', label: 'كوسوفو' },
    { value: 'XI', label: 'المملكة المتحدة (أيرلندا الشمالية)' },
  ].map((country) => ({
    value: country.value,
    label: country.value
      ? `${country.value} - ${country.label}`
      : country.label,
  })),
};
